import _ from 'lodash'
import { option } from '../lib/common'
import { THEME_FORM_FIELD_ELEMENTS } from './THEME_FORM_FIELD_ELEMENTS'

export const THEME_FORM_FIELD_ELEMENTS_KEYS = _.map(THEME_FORM_FIELD_ELEMENTS, (v) => v.value)

export const FORM_FIELD_VARIANT_TYPE = {
  STANDARD: 'standard',
  FILL: 'filled',
  OUTLINED: 'outlined',
  FIXED: 'fixed',
  CLASSIC: 'classic',
}

export const FORM_FIELD_VARIANT = [
  option('Standard', FORM_FIELD_VARIANT_TYPE.STANDARD),
  option('Filled', FORM_FIELD_VARIANT_TYPE.FILL),
  option('Outlined', FORM_FIELD_VARIANT_TYPE.OUTLINED),
  option('Fixed', FORM_FIELD_VARIANT_TYPE.FIXED),
  option('Classic', FORM_FIELD_VARIANT_TYPE.CLASSIC),
]

export const FORM_FIELD_UPLOAD_ICON_VARIANT = [
  option('Top', 'top'),
  option('Right', 'right'),
  option('Bottom', 'bottom'),
  option('Left', 'left'),
]

export const FORM_FIELD_SIZE_VARIANT = [option('Medium', 'medium'), option('Small', 'small')]

export const FORM_FIELD_BTN_SIZE_VARIANT = [
  option('Large', 'large'),
  option('Medium', 'medium'),
  option('Small', 'small'),
]

export const FORM_FIELD_FILE_UPLOAD_VARIANT = [
  option('DropZone', 'dropzone'),
  option('Input', 'button'),
  option('Button', 'btn'),
]

export const FORM_FIELD_RADIO_VARIANT = [option('Vertical', 'row'), option('Horizontal', 'column')]

export const BUTTON_GROUP_VARIANT = [
  option('Outlined', 'outlined'),
  option('Contained', 'contained'),
  option('Text', 'text'),
]

export const BUTTON_GROUP_ORIENTATION = [option('Horizontal', 'horizontal'), option('Vertical', 'vertical')]

export const BLUR_TEXT_BASED_FIELDS = [
  'text',
  'textarea',
  'addressFinder',
  'externalLookup',
  'email',
  'url',
  'number',
  'currency',
  'phone',
]
export const TEXT_BASED_FIELDS = [
  'text',
  'textarea',
  'select',
  'multiSelect',
  'addressFinder',
  'externalLookup',
  'email',
  'url',
  'number',
  'currency',
  'date',
  'time',
  'datetime',
  'lookup',
  'richtextarea',
  'daterange',
  'phone',
]

export const FORM_FIELD_TYPE = [
  option('Text', 'text'),
  option('Address Finder', 'addressFinder'),
  option('External Lookup', 'externalLookup'),
  option('TextArea', 'textarea'),
  option('Rich TextArea', 'richtextarea'),
  option('Email', 'email'),
  option('Number', 'number'),
  option('Phone', 'phone'),
  option('Currency', 'currency'),
  option('Slider', 'slider'),
  option('URL', 'url'),
  option('Date', 'date'),
  option('Time', 'time'),
  option('DateTime', 'datetime'),
  option('Checkbox', 'checkbox'),
  option('Switch', 'switch'),
  option('Radio', 'radio'),
  option('Select', 'select'),
  option('Multi Select', 'multiSelect'),
  option('ButtonGroup', 'buttongroup'),
  option('Lookup', 'lookup'),
  option('File Upload', 'fileupload'),
  option('Signature', 'signature'),
]

export const formFieldTypeToText = (type) =>
  _.find(FORM_FIELD_TYPE, (v) => v.value === type)?.label || _.capitalize(type)
